module.exports = __webpack_public_path__ + "media/images/talent/feature05-79bd8c57e59e9c988943c39e8833fda0.png";